import * as Yup from 'yup'

const validateFile = (allowedExtensions: string[], maxSize: number) => {
    return Yup.mixed()
        .required('File is required')
        .test(
            'fileSize',
            `File size is too large, max size is ${maxSize / (1024 * 1024)}MB`,
            (value: any) => {
                if (typeof value === 'object' && value !== null) {
                    return value && value.size <= 200 * 1024 * 1024 // 200 MB
                }
                return true
            }
        )
        .test(
            'fileType',
            'Unsupported file format ( only pdf, word files and videos are allowed )',
            (value: any, context) => {
                if (typeof value === 'object' && value !== null && value.type) {
                    const fileExt = context?.parent?.file?.name
                        ?.split('.')
                        .slice(-1)[0]
                    const res = allowedExtensions.some((ext) =>
                        ext.toLowerCase().endsWith(fileExt)
                    )
                    return res
                }
                return true
            }
        )
}

const allowedExtensions = [
    '.doc',
    '.docx',
    '.pdf',

    '.mp4',
    '.avi',
    '.mkv',
    '.mov',
    '.wmv',
    '.flv',
    '.mpg',
    '.mpeg',
    '.3gp',
    '.webm',
]
const maxSize = 200 * 1024 * 1024 // 200 MB

const formSchema = Yup.object().shape({
    title: Yup.string().required('Title is required'),
    file: validateFile(allowedExtensions, maxSize),
    fileName: Yup.string().notRequired(),
})

const fileUploadSchema = Yup.object().shape({
    file: validateFile(allowedExtensions, maxSize),
    fileName: Yup.string().notRequired(),
})
export { formSchema, fileUploadSchema }
